import { TagDTO } from '@gearbelt/global';
import { v4 as uuidv4 } from 'uuid';

import { UpdateWorkspaceEntityDialog, type UpdateWorkspaceEntityDialogConfig } from '@/components/settings/update-workspace-entity-dialog';

const tagConfig: UpdateWorkspaceEntityDialogConfig<TagDTO> = {
  title: 'Issue Tags',
  description: 'These allow you to group issues under custom tags. You can edit, remove, and add new tags. All tags are editable at once.',
  createEmptyItem: () => ({
    id: uuidv4(),
    tag: '',
    order: 9999,
  }),
  getValue: (item) => item.tag,
  setValue: (item, value) => ({ ...item, tag: value }),
};

function UpdateWorkspaceIssueTags({
  issueTags,
  open,
  onOpenChange,
  callback,
}: {
  issueTags: TagDTO[] | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (tags: TagDTO[]) => void;
}) {
  return <UpdateWorkspaceEntityDialog items={issueTags} open={open} onOpenChange={onOpenChange} callback={callback} config={tagConfig} />;
}

export { UpdateWorkspaceIssueTags };
